import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .icon {
    position: absolute;
    padding: 3px 0px 0px 4px;
    color: ${colors.primary.dark};
    font-size: 16px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/accountant-area/fiscal-info/styles.js